@if (!application) {
  <loading-indicator [loadingMessage]="'Loading loan summary, please wait...'"></loading-indicator>
}
@if (application && !isReverse) {
  <div class="container-fluid px-0">
    <div class="card">
      <div class="card-body">
        <div class="tpo-loan-summary-grid">
          @for (s of orderedSections; track s.section) {
            <div [ngClass]="getWidthClass(s.width)">
              @switch (s.section) {
                @case ('Borrowers') {
                  <tpo-borrower [borrowers]="borrowers" [mortgage]="mortgage"></tpo-borrower>
                }
                @case ('LoanStatus') {
                  <tpo-loan-status [loanStatus]="loanStatus" [application]="application"
                    [isTpoSubmitted]="isTpoSubmitted" [subStatus]="subStatus"></tpo-loan-status>
                }
                @case ('LoanDetails') {
                  <tpo-loan-detail [application]="application" [mortgage]="mortgage"
                    [mortgageCalculationDetails]="mortgageCalculationDetails"></tpo-loan-detail>
                }
                @case ('OriginationInfo') {
                  <tpo-origination-info [application]="application" [isPRMG]="isPRMG"
                    [hiddenFields]="hiddenFields"></tpo-origination-info>
                }
                @case ('ClosingInfo') {
                  <tpo-closing-info [application]="application" [hiddenFields]="hiddenFields"></tpo-closing-info>
                }
                @case ('KeyDates') {
                  <div class="accordion">
                    <div class="accordion-item">
                      <h2 class="accordion-header m-0">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseKeyDates" aria-expanded="false" aria-controls="collapseKeyDates">
                          Key Dates
                        </button>
                      </h2>
                      <div id="collapseKeyDates" class="accordion-collapse collapse">
                        <div class="accordion-body">
                          <key-dates></key-dates>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @case ('EsignatureHistory') {
                  <div class="accordion">
                    <div class="accordion-item">
                      <h2 class="accordion-header m-0">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseEsig" aria-expanded="false" aria-controls="collapseEsig">
                          E-Signature History
                        </button>
                      </h2>
                      <div id="collapseEsig" class="accordion-collapse collapse">
                        <div class="accordion-body">
                          <app-tpo-esignature-history></app-tpo-esignature-history>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          }
          @if (showCustomInfo) {
            <div class="section-col-4">
              <div class="card" id="customInfo">
                <div class="card-header d-flex align-items-center justify-content-between">
                  <h4 class="card-title mb-0">
                    <i class="fas fa-key me-2"></i>
                    {{ customInfoSectionTitle }}
                  </h4>
                  <button type="button" class="btn btn-sm btn-primary"
                    [disabled]="isLoanReadOnly || isSavingCustomInfo" (click)="saveCustomInfo()">
                    <i class="fas fa-save me-1"></i>
                    {{ isLoanReadOnly ? 'Save (Readonly)' : 'Save' }}
                  </button>
                </div>
                <div class="card-body">
                  <form #customInfoForm="ngForm" novalidate id="customInfoForm" name="customInfoForm">
                    <div class="row">
                      <custom-data-info #customDataInfo [applicationId]="application?.applicationId"
                        [userType]="userType" [customData]="customData" [isInClassicEditMode]="true"
                        [labelAlignment]="'left'" (customDataInfoInitialized)="onCustomDataInfoInitialized()">
                      </custom-data-info>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
@if (application && isReverse) {
  <tpo-loan-summary-reverse></tpo-loan-summary-reverse>
}
